module.exports = __webpack_public_path__ + "static/media/textediter_title_active.e2f99a1f.svg";